export default "__VITE_ASSET__tGlSiPyo__"